import React from 'react'
import { useTranslation } from 'react-i18next'
import { EmptyState } from '@node-space/ui-components'
import { Lottie } from 'components/Animations/SimpleLottie'

export const MassPayoutEmptyState = () => {
  const { t } = useTranslation()

  return (
    <EmptyState
      testId="empty-state"
      LottiePlayer={<Lottie src="no-data" />}
      title={t('massPayouts.massPayoutsEmptyHeader')}
      description={t('massPayouts.massPayoutsEmptyDescription')}
    />
  )
}
